module.exports = __webpack_public_path__ + "static/media/link.66293e06.svg";